import script from "./LayerUI.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerUI.vue?vue&type=script&setup=true&lang=js"

import "./LayerUI.vue?vue&type=style&index=0&id=4b3d0a0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3d0a0e"]])

export default __exports__